module Meevo.Plugins.CustomBranding {
    "use strict";
    import ICustomBranding = Meevo.Model.ICustomBranding;
    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;

    export interface IStyleConfig {
        'color': string,
        'font-family': string,
        'font-weight': string,
        'font-style': string,
        'text-decoration': string
    }

    interface IFont {
        displayName: string;
    }

    export enum TabIdsEnum {
        stockLibrary = 1,
        customImage = 2,
        gradientColors = 3
    }

    export interface ITab {
        displayName: string;
        tabId: TabIdsEnum
    }

    export interface ITabs {
        stockLibrary: ITab;
        customImage: ITab;
        gradientColors: ITab;
    }

    /**
     * Base Section of Custom Branding
     */
    export class CustomBrandingBaseSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<ICustomBranding> {
        private _fontList: Array<IFont>;
        private _bodyTextFontList: Array<IFont>;
        public tenantName: string;
        private tenantNameStyleConfig: IStyleConfig;
        public modalService: Meevo.Components.Modal.IModalService;
        public $q: ng.IQService;
        public busyService: Meevo.Components.Busy.IBusyService;
        public cover: boolean;

        public tabs: ITabs;
        public selectedTab: number;

        constructor (params: Meevo.Model.ISectionParamsBaseDataService) {
            const {sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud,
                baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, modalService, sectionSecurityKey} = params;

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud,
                baseEndpoint, sectionEndpoint, loggingService, dataService, null, null, null, sectionSecurityKey);

            this.tenantName = identityService.tenantName;
            this.modalService = modalService;
            this.$q = params.$q;
            this.busyService = params.busyService;

            this.fontList = [
              { displayName: 'Helvetica, Arial, Tahoma' },
              { displayName: 'Times New Roman, Georgia' },
              { displayName: 'Courier New, Monaco' },
              { displayName: 'Impact, Charcoal, sans-serif' },
              { displayName: 'Century Gothic, sans-serif' },
              { displayName: 'Comic Sans MS, cursive, sans-serif' }
            ];

            this.bodyTextFontList = [
                { displayName: 'Helvetica, Arial, Tahoma' },
                { displayName: 'Times New Roman, Georgia' },
                { displayName: 'Courier New, Monaco' },
                { displayName: 'Century Gothic, sans-serif' },
                { displayName: 'Comic Sans MS, cursive, sans-serif' }
            ];

            this.tabs = {
                stockLibrary: {
                    displayName: params.$translate.instant('LABEL_STOCK_LIBRARY'),
                    tabId: TabIdsEnum.stockLibrary
                },
                customImage: {
                    displayName: params.$translate.instant('LABEL_CUSTOM_IMAGE'),
                    tabId: TabIdsEnum.customImage
                },
                gradientColors: {
                    displayName: params.$translate.instant('LABEL_GRADIENT_COLORS'),
                    tabId: TabIdsEnum.gradientColors
                }
            };

            this.cover = false;
        }

        public activate(): void {
            super.activate();

            this.buildTenantNameStyle();

            if (Model.Guard.isSomething(this.model)) {
              // initialize text font properties
                let initialFont = _.first(this.fontList);

                if (Model.Guard.isNothing(this.model.displayTextFont))
                    this.model.displayTextFont = initialFont.displayName;
                if (Model.Guard.isNothing(this.model.customMessageFont))
                    this.model.customMessageFont = initialFont.displayName;
                if (Model.Guard.isNothing(this.model.pageDisplayTextFont))
                    this.model.pageDisplayTextFont = initialFont.displayName;
                if (Model.Guard.isNothing(this.model.bodyDisplayTextFont))
                    this.model.bodyDisplayTextFont = initialFont.displayName;
            }
        }

        /**
         * Build style object for slogan
         * */
        private buildTenantNameStyle(): void {
            let prefix = this.cover ? 'display' : 'pageDisplay';

            this.tenantNameStyle = {
                'color': this.model[`${prefix}TextColor`] || '#000',
                'font-family': this.model[`${prefix}TextFont`],
                'font-weight': this.model[`${prefix}TextFontBold`] ? 'bold' : 'normal',
                'font-style': this.model[`${prefix}TextFontItalicize`] ? 'italic' : 'normal',
                'text-decoration': this.model[`${prefix}TextFontUnderline`] ? 'underline' : 'none',
            };
        }

        get tenantNameStyle(): IStyleConfig {
            return this.tenantNameStyleConfig;
        }

        set tenantNameStyle(style: IStyleConfig) {
            this.tenantNameStyleConfig = style;
        }

        /**
         * Get image url
         * @param {StorageTypeEnum} storageTypeEnum
         * @param {Guid} fileGuid
         * @returns {angular.IPromise}
         */
        public getImageUrl(storageTypeEnum: StorageTypeEnum, fileGuid: Guid | string): angular.IPromise<any> {
            if (!fileGuid) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData(`/api/storage/customBrandingImage/${storageTypeEnum}/${fileGuid}`, 'GET', null);
        }

        /**
         * Save image to storage
         * @param {IStorageFile} file
         * @returns {angular.IPromise}
         */
        public saveImageToStorage(file: IStorageFile = {}): angular.IPromise<any> {
            if (!Object.keys(file).length || (file && !file.meevoFile)) {
                return this.$q.resolve({});
            }

            return this.dataService.customMethodData('/api/storage/customBrandingImage', 'POST', {
                customBrandingImageResource: _.extend(file, { resourceType: file.meevoFile['storageTypeEnum'] })
            });
        }

        set fontList(fonts: Array<IFont>) {
            this._fontList = fonts;
        }

        get fontList(): Array<IFont> {
            return this._fontList;
        }

        get storageTypeEnum(): any {
            return StorageTypeEnum;
        }


        set bodyTextFontList(bodyFonts: Array<IFont>) {
            this._bodyTextFontList = bodyFonts;
        }

        get bodyTextFontList(): Array<IFont> {
            return this._bodyTextFontList;
        }

        public canSaveLogic(): boolean {
            return true;
        }
    }
}